import { makeStyles, Theme } from '@material-ui/core'
import { IconProps } from './IconProps'

type StyleProps = Pick<IconProps, 'color' | 'size'>

export const useIconStyles = makeStyles<Theme, StyleProps>(({ spacing, palette }) => {
  const getFontSize = ({ size }: StyleProps) => {
    switch (size) {
      case 'small':
        return spacing(1.5)
      case 'medium':
        return spacing(2)
      case 'large':
        return spacing(2.5)
      case 'extra-large':
        return spacing(3)
      default:
        return 'inherit'
    }
  }

  const getColor = (props: StyleProps) => {
    const semanticColors = ['primary', 'secondary', 'info', 'success', 'warning', 'error']
    let value = 'inherit'
    if (props.color) {
      if (semanticColors.includes(props.color.split('.')[0])) {
        const [color, variant = 'main'] = props.color.split('.')
        // @ts-expect-error - todo.
        value = palette[color][variant]
      } else if (props.color.search(/^(rgb|hsla|#)/) !== -1) {
        value = props.color
      }
    }
    return value
  }

  return {
    root: {
      color: getColor,
      fontSize: getFontSize,
      width: '1em',
      height: '1em',
      strokeWidth: '1.3px',
    },
  }
})
